import usePreventClickOnDrag from '@activities/MainActivity/components/MainBanners/hooks/usePreventClickOnDrag';
import queries from '@apis/queries';
import BannerCounter from '@components/BannerCounter';
import Image from '@components/Image';
import Indicator from '@components/Indicator';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import useOnBannerClick from '@hooks/banner/useOnBannerClick';
import { useQuery } from '@tanstack/react-query';
import { Fragment, useState } from 'react';
import Slider from 'react-slick';

function Banner2() {
  const banners = (useQuery(queries.banners.list('MAIN_2'))).data?.banners;
  const [index, setIndex] = useState<number>(0);
  const { beforeChange, afterChange, onDragItemClick } = usePreventClickOnDrag();
  const onBannerClick = useOnBannerClick();
  if (banners && banners.length !== 0) {
    return (
         <Container>
           {banners.length === 1 ? (
               <StyledImage src={banners[0].imageUrl}
                            css={css`
                              margin-left: 0;
                            `}
                            onClick={() => {
                              onDragItemClick(() => onBannerClick(banners[0]));
                            }}
                            alt={banners[0].contentType} />
           ) : (
               <Fragment>
                 <Slider dots={false}
                         beforeChange={beforeChange}
                         afterChange={(newIndex) => {
                           setIndex(newIndex);
                           afterChange();
                         }}>
                   {banners.map((banner, i) => (
                       <div key={`${banner.contentId} ${i}`}
                            onClick={() => {
                              onDragItemClick(() => onBannerClick(banner));
                            }} >
                         <StyledImage src={banner.imageUrl}
                                      alt={banner.contentType} />
                       </div>
                   ))}
                 </Slider>
                 <BannerCounter totalCount={banners.length}
                                right={20}
                                bottom={2}
                                index={index} />
               </Fragment>
           )}
         </Container>
    );
  }
  return (<Fragment/>);
}

const Container = styled.div`
  margin:  0 0 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 6px;
  position: relative;
`;

const StyledImage = styled(Image)`
    object-fit: cover;
    aspect-ratio: 4.21;
    border-radius: 8px;
    overflow: hidden;
    width: calc(100% - 40px);
    margin-left: 20px;
`;

export default Banner2;
